import { httpClient } from '../http/httpClient'

export interface getWithDrawByIdResponse {
  _id: string
  user: string
  amount: number
  balance: number
  request_control_key: string
  end_to_end_id: string
  pix_transfer_key: string
  type: 'A' | 'M'
  status: 'UNPAID' | 'PAID' | 'PENDING'
  createdAt: string
  updatedAt: string
  __v: number
  errorOnUpdate?: string
}

export async function getWithdrawById(id: string) {
  const { data } = await httpClient.get<getWithDrawByIdResponse>(
    `/withdraw/${id}/pix`,
  )

  return data
}
